import { cn } from "@/lib/cn";
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";

/** Props of `ZoomableImage`; `label` names the action for screen readers, `className` is for layout. */
export type ZoomableImageProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onClick" | "aria-label" | "children"> & {
  onZoom: () => void;
  label?: string;
  children: ReactNode;
};

/** Wraps a photo in a real button that opens it enlarged (keyboard, focus ring, accessible name). */
export const ZoomableImage = forwardRef<HTMLButtonElement, ZoomableImageProps>(function ZoomableImage(
  { onZoom, label = "Ampliar imagem", className, children, type = "button", ...rest },
  ref,
) {
  return (
    <button
      {...rest}
      ref={ref}
      type={type}
      aria-label={label}
      onClick={onZoom}
      className={cn(
        "block cursor-zoom-in text-left",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2",
        className,
      )}
    >
      {children}
    </button>
  );
});
